import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import NavComponent from "./components/Nav/Nav";
import Footer from "./components/Footer/Footer";
import Popup from "./components/Popup/Popup";
import Popup2 from "./components/Popup2/Popup2";
import PopupCity from "./components/PopupCity/PopupCity";
import Drower from "./components/Drower/Drower";
import { useStoreState } from "easy-peasy";
import { useLocation } from "react-router-dom";

const Layout = ({ children, title = "Фармация" }) => {
  const color = useStoreState((state) => state.color.color);
  const textColor = useStoreState((state) => state.color.textColor);
  const accordionColor = useStoreState((state) => state.color.accordionColor);
  const iconColor = useStoreState((state) => state.color.iconColor);
  const location = useLocation();
  const metas = useStoreState((state) => state.meta.metas);
  const [meta, setMeta] = useState({});

  useEffect(async () => {
    // const store = require("./client");
    // const ip = localStorage.getItem("ip");
    // const ipExp = localStorage.getItem("ipExp");
    // const city = localStorage.getItem("city");
    // const cityExp = localStorage.getItem("cityExp");
    // if (!ip || !ipExp || ipExp < Date.now()) {
    //   localStorage.removeItem("ip");
    //   localStorage.removeItem("ipExp");
    //   await store.default.dispatch.cityIp.getIp();
    // } else {
    //   await store.default.dispatch.cityIp.setIp(ip);
    // }
    // if (!city || !cityExp || cityExp < Date.now()) {
    //   localStorage.removeItem("city");
    //   localStorage.removeItem("cityExp");
    //   await store.default.dispatch.cityIp.getCityResponse();
    // } else {
    //   await store.default.dispatch.cityIp.setCity(city);
    // }
    // if (store.default.getState().cityIp.city != "") {
    //   store.default.dispatch.cityIp.setCity(
    //     store.default.getState().cityIp.city
    //   );
    // }
    const root = document.documentElement;
    root.style.setProperty("--gradiaentMy", color);
    root.style.setProperty("--mainText", textColor);
    root.style.setProperty("--accordion", accordionColor);
    root.style.setProperty("--iconColor", iconColor);
  }, []);

  useEffect(() => {
    const localMeta = metas.filter((el) =>
      location.pathname.includes(el.path)
    )[0];
    if (localMeta) {
      setMeta(localMeta);
    } else {
      setMeta({});
    }
  }, [location]);

  return (
    <div className="mainMain">
      <Helmet>
        <title>{meta.title ? meta.title : "Фармация"}</title>
        <meta
          name="description"
          content={
            meta.description
              ? meta.description
              : "Аптечная сеть Фармация, 75 лет заботится о вашем здоровье!"
          }
        />
        <meta name="robots" content="index, follow" />
        <meta
          name="keywords"
          content={
            meta.keywords ? meta.keywords : "аптека, здоровье, лекарства"
          }
        />
      </Helmet>
      <NavComponent></NavComponent>
      {children}
      <Footer />
      <Drower />
      <Popup />
      <Popup2 />
      <PopupCity />
    </div>
  );
};

export default Layout;
